import graphql__0fe67cadb749ec033987 from "./__generated__/PageSectionEmbed_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../Intl/Context";
import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";
import ButtonLink from "../Buttons/ButtonLink";
import RichText from "../Utils/RichText";
import VideoPlayer from "../Media/VideoPlayer";
import AudioPlayer from "../Media/AudioPlayer";

const PageSectionEmbed = props => {
  const pageSection = useFragment(PageSectionEmbed_pageSection, props.pageSection);
  const {
    title,
    description,
    code,
    url,
    hlsUrl,
    audio,
    iconClass,
    format,
    isEmpty,
    mediaTitle,
    collapsible,
    collapsedHeight
  } = pageSection;
  const transcriptionUrl = pageSection.transcription?.url;

  const t = useFormatMessage();
  const transcriptionLabel = t(intlMessages.transcriptionLabel);

  // Convert stored format (ex: 16x9) to bootstrap-compatible format (ex: 16by9)
  //
  const hasFormat = format && format !== "default";
  const formatClassName = hasFormat && format.replace("x", "by");

  const contentClassName = classNames("line-height-none", {
    "embed-responsive": hasFormat,
    ["embed-responsive-" + formatClassName]: hasFormat
  });

  const isVideoPlayer = hlsUrl;
  const isEmbedCode = !hlsUrl && code;
  const isURL = !hlsUrl && url;
  const isAudioPlayer = !hlsUrl && audio?.url;

  if (isEmpty) return null;

  return (
    <PageSectionBlockWithTitleAndDescription
      title={title}
      description={description}
      iconClassName={iconClass}
      collapsible={collapsible}
      collapsedHeight={collapsedHeight}
    >
      {isVideoPlayer && <VideoPlayer withVideoStream={pageSection} />}

      {isEmbedCode && (
        <RichText className={contentClassName} content={code} allowScriptTags />
      )}

      {isURL && (
        <div className={contentClassName}>
          <iframe title={mediaTitle} src={url} />
        </div>
      )}

      {isAudioPlayer && <AudioPlayer audio={audio} />}

      {transcriptionUrl && (
        <ButtonLink
          href={transcriptionUrl}
          className="page-section-embed-transcription btn btn-default btn-sm margin-top-sm"
          label={transcriptionLabel}
          iconClassName="icon-document"
          target="_blank"
        />
      )}
    </PageSectionBlockWithTitleAndDescription>
  );
};

const PageSectionEmbed_pageSection = graphql__0fe67cadb749ec033987;

export default PageSectionEmbed;

const intlMessages = defineMessages({
  transcriptionLabel: {
    id: "pageSection.embed.transcriptionLabel",
    defaultMessage: "Télécharger la transcription textuelle du média"
  }
});
